(function () {
  "use strict";

  DeleteCatalogCtrl.$inject = ['$scope', '$rootScope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('DeleteCatalogCtrl', DeleteCatalogCtrl);

  function DeleteCatalogCtrl($scope, $rootScope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      confirmed: false
    };

    $scope.deleteCatalog = function () {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      $rootScope.$broadcast('catalogDeletionConfirmedEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('catalogDeletionRequestedEvent', function (event, catalog) {
      $scope.modal.status = '';
      $scope.modal.data = catalog.id;
      $scope.modal.content = catalog.name;
      $scope.modal.confirmed = false;
      $scope.show();
    });
  }

})();
